import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { Chip, Box, IconButton } from "@mui/material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
// import HistoryIcon from '@mui/icons-material/History';

import { Statuses } from "../common/constant";

const InspectionTile = (props) => {
  const { inspectionMasterId, propertyName, date, inspector, status, } = //inspectionRefNumber,propertyMasterId } = 
    props.tableData;
  const {
    openEditScreen,
    // openAuditScreen,
    openScheduleScreen,
    tableData,
    setPropertyToDelete,
    setShowConfirmationPopup,
  } = props;

  const isActionDisabled = status === Statuses.CANCELLED ? true : false;
  const isNew = (status === Statuses.NEW  || status === Statuses.SCHEDULED ) ? true : false;
  const isCompleted = (status === Statuses.COMPLETED || status === Statuses.REJECTED) ? true : false;
  const getChipStyle = (status) => {
          switch (status) {
            case Statuses.INPROGRESS:
              return {
                backgroundColor: "#FFA50033",
                color: "#CB8300",
                height: "20px",
              }; // orange

            case Statuses.SCHEDULED:
              return {
                backgroundColor: "#DBEAFE",
                color: "#081634",
                height: "20px",
              }; // blue
            case Statuses.COMPLETED:
              return {
                backgroundColor: "#DCFCE7",
                color: "#1B2C1B",
                height: "20px",
              }; // green
            case Statuses.SUBMITTEDFORAPPROVAL:
              return{
                backgroundColor: "#fff0b4",
                color: "#382f09ff",
                height: "20px",
              };
            case Statuses.REJECTED:
              return{
                backgroundColor: "#E520201A",
                color: "#E52020",
                height: "20px",
              };
            case Statuses.NEW:
              return{
                backgroundColor: "#dedbfe",
                color: "#54526bff",
                height: "20px",
              };
            default:
              return {
                backgroundColor: "#c3cac7ff",
                color: "#323a32ff",
                height: "20px",
              };
          }
        };
  return (
    <div className="row col-12 col-sm-12 mb-3 resident-card">
      <div className="d-flex flex-column gap-1 justify-content-start align-items-start p-3">
        <p className="inspection-tile-header">{propertyName}</p>
        <span className="d-flex flex-row  align-items-center">
          <PersonSearchIcon fontSize="small" />
          <p className="inspection-tile-label">{inspector}</p>
        </span>
        <span className="d-flex flex-row  align-items-center">
          <DateRangeIcon fontSize="small" />
          <p className="inspection-tile-label">{date}</p>
        </span>
        <div className="d-flex flex-row justify-content-between align-items-center pt-1 w-100">
          <Chip label={status} sx={getChipStyle(status)} />
          <Box>
            <IconButton
              disabled={isActionDisabled || isCompleted}
              tabIndex={0}
              title="Edit Inspection"
              onClick={() => openEditScreen(inspectionMasterId)}
            >
              <EditOutlinedIcon sx={(isActionDisabled || isCompleted) ? {color: "#c3cac7ff"} : { color: "#EF3800" }} fontSize="small" />
            </IconButton>
            <IconButton
              disabled={isActionDisabled || !isNew}
              tabIndex={0}
              title="Schedule Inspection"
              onClick={() => openScheduleScreen(inspectionMasterId)}
            >
              <CalendarMonthOutlinedIcon
                sx={(isActionDisabled || !isNew) ? {color: "#c3cac7ff"} : { color: "#EF3800" }}
                fontSize="small"
              />
            </IconButton>
            <IconButton
              disabled={isActionDisabled || isCompleted}
              tabIndex={0}
              title="Delete Inspection"
              onClick={() => {
                setPropertyToDelete(tableData);
                setShowConfirmationPopup(true);
              }}
            >
              <DeleteOutlineIcon sx={(isActionDisabled || isCompleted) ? {color: "#c3cac7ff"} : { color: "#EF3800" }} fontSize="small" />
            </IconButton>
            {/* <IconButton
                          // disabled={isActionDisabled}
                          tabIndex={0}
                          title="Booking History"
                          onClick={() => openAuditScreen(inspectionRefNumber,propertyMasterId)}
                        >
                          <HistoryIcon sx={  { color: "#EF3800" }} fontSize="small" />
                        </IconButton> */}
          </Box>
        </div>
      </div>
    </div>
  );
};

export default InspectionTile;
